// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__PGRLI","title":"Images90_title__slr-v","images":"Images90_images__3n7vO"};